import { Resource as i, API as h } from "@coveo/platform-client";
const t = class t extends i {
  /**
   * Preview the impact of creating a listing rule on a config.
   * @param rulePreviewRequest
   * @param options
   * @returns The products that would be returned.
   */
  create(r, e = {}) {
    return this.api.post(
      this.buildPath(t.baseUrl, e),
      r
    );
  }
  /**
   * Preview the impact of an updated listing rule vs not having the rule,
   * or if `compareWithPreviousState` is true, the impact of a rule update
   * vs the previous state of the rule.
   * @param ruleId
   * @param rulePreviewRequest
   * @param options
   * @returns The products that would be returned.
   */
  update(r, e, s = {}) {
    return this.api.put(
      this.buildPath(`${t.baseUrl}/${r}`, s),
      e
    );
  }
  /**
   * Preview the impact of a listing rule.
   * @param ruleId
   * @param rulePreviewRequest
   * @param options
   * @returns The products that would be returned.
   */
  get(r, e, s = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${r}`, { ...e, ...s })
    );
  }
};
t.baseUrl = `/rest/organizations/${h.orgPlaceholder}/commerce/v2/listing/preview/rules`;
let a = t;
export {
  a as ListingRulePreview
};
//# sourceMappingURL=ListingRulePreview.js.map
